import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { useInfiniteQuery } from 'react-query';
import { useMemo } from 'react';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { WorkerOptions } from '../wizard/time-slot.types';

export const useGetCompanyEmployees = () => {
  const query = useInfiniteQuery({
    queryKey: QUERY_KEYS.workforce(),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedWorkforceService.getEmployees({
        pageParam,
        labourEngagementStates: ['approved'],
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });

  const workerOptions = useMemo<WorkerOptions[]>(() => {
    const employees = query.data?.pages.flatMap((page) => page.items) ?? [];
    return employees.map((employee) => ({
      id: employee.id,
      name: getFullNameWithInfix({
        firstName: employee.firstName,
        lastName: employee.lastName,
        infix: employee.infix ?? null,
      }),
      description: employee.email,
    }));
  }, [query.data]);

  return {
    ...query,
    workerOptions,
  };
};
